<template>
	<div class="p-fluid formgrid grid card">
		<template v-if="loader==true">
			<div class="col-12 mb-2 lg:col-12">
				<ProgressBar mode="indeterminate" style="height: .5em" class="my-1"/>
			</div>
		</template>
		<div class="col-12 lg:col-12">
			<h4>Administrar Clientes</h4>
		</div>
		<div class="col-1 my-1">
			<Button label="Nuevo" icon="pi pi-plus" class="p-button-rounded p-button-prymary" :loading="loader" @click="openNewClient" />
		</div>
		<div class="col-3 lg:col-2 my-1">
			<span class="p-float-label">
				<InputText v-model="frmfiltros.nit_customer" id="doc_conductor" type="number" />
				<label for="doc_conductor">NIT</label>
			</span>
		</div>
		<div class="col-3 lg:col-2 my-1">
			<span class="p-float-label">
				<InputText v-model="frmfiltros.name_customer" id="name_customer" />
				<label for="name_customer">Razón Social</label>
			</span>
		</div>

		<div class="col-3 mt-1">

		</div>

		<div class="col-2 lg:col-2 my-1">
			<Button label="Buscar" icon="pi pi-search" class="p-button-rounded p-button-prymary" :loading="loader" @click="cargar_clientes(1)" />
		</div>
		<div class="col-2 lg:col-2 my-1">
			<Button label="Limpiar" icon="pi pi-filter-slash" class="p-button-rounded p-button-prymary" :loading="loader" @click="limpiar" />
		</div>
		<div class="col-12 lg:col-12 mt-2">
		
		<DataTable ref="pagination" :value="clientes" v-model:selection="selectedClients" dataKey="id" :paginator="false" :rows="3" @paginate="onChangePage"
							:paginatorTemplate="'CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown'"
							:currentPageReportTemplate="'Showing '+pagination.from+' to '+pagination.to+' of '+pagination.total+' customers'" responsiveLayout="scroll">
					<Column field="document" header="NIT" :sortable="false">
						<template #body="slotProps">
							<span class="p-column-title">NIT</span>
							{{slotProps.data.document}}
						</template>
					</Column>
					<Column field="name" header="Razón Social" :sortable="false">
						<template #body="slotProps">
							<span class="p-column-title">name</span>
							{{slotProps.data.name}}
						</template>
					</Column>
					<Column field="contact" header="Contacto" :sortable="false">
						<template #body="slotProps">
							<span class="p-column-title">contact</span>
							{{slotProps.data.contact}}
						</template>
					</Column>
					<Column field="status" header="Estado" :sortable="false">
						<template #body="slotProps">
							<span class="p-column-title">estado</span>
							<template v-if="slotProps.data.status==1 && slotProps.data.idel==0">
								<Badge value="ACTIVA" severity="primary" class="mt-1"></Badge>
							</template>
							<template v-if="slotProps.data.status==0 && slotProps.data.idel==0">
								<Badge value="INACTIVA" severity="warning" class="mt-1"></Badge>
							</template>
							<template v-if="slotProps.data.idel==1">
								<Badge value="BLOQUEADA" severity="danger" class="mt-1"></Badge>
							</template>
						</template>
					</Column>
					<Column field="acciones" header="Acciones">
						<template #body="slotProps">
							<Button icon="pi pi-file-edit" title="Editar Información" class="p-button-rounded p-button-success p-button-outlined" :disabled="loader" @click="openmodalClientes(slotProps.data)" />
						</template>
					</Column>
				</DataTable>
				<div>
					<Paginator :v-model:first="pagination.from" :rows="pagination.per_page" :rowsPerPageOptions="[10]" :totalRecords="pagination.total" @page="onChangePage($event)"></Paginator>
				</div>
		</div>
		<Dialog v-model:visible="modalcliente" :style="{width: '950px'}" :header="frmCliente.name ?? 'Crear Cliente'" :modal="true" class="p-fluid">
			<div class="field formgrid grid my-3">
				<!-- <p>{{frmCliente}}</p> -->
				<div class="col-4">
					<template v-if="frmCliente.id!=0">
						<div class="text-center">
							<template v-if="frmCliente.url == '' || frmCliente.url == null">
								<div :style="'background: #'+frmCliente.color_tapiz" class="align-items-center">
									<i class="pi pi-image mt-3 px-8 text-600 cursor-pointer" @click="openmodalmediaCustomer" style="font-size: 7rem"></i>
									
								</div>
								
							</template>
							<template v-else>
								<div :style="'background: #'+frmCliente.color_tapiz">
									<img class="my-5 cursor-pointer" :src="frmCliente.url" alt="profile" @click="openmodalmediaCustomer" width="250">
								</div>
							</template>
						</div>
					</template>

					<div class="col-12 mt-3">
						<h5>Controles:</h5>
						<!-- <template v-if="frmCliente.status==1 && frmCliente.idel==0"> -->
							<div class="text-center">
								<h6>Estado de la Empresa</h6>
							
								<InputSwitch v-model="frmCliente.estado" @change="handleChange" /><br>
								<div class="mt-2 ml-2">
									<template v-if="frmCliente.status==1">
										<Badge value="ACTIVA" severity="primary" ></Badge>
									</template>
									<template v-if="frmCliente.status==0">
										<Badge value="INACTIVA" severity="warning" ></Badge>
									</template>
								</div>

								<h6>Disponibilidad de la Empresa</h6>
							
								<InputSwitch v-model="frmCliente.disponibilidad" @change="handleChangeIdel" /><br>
								<div class="mt-2 ml-2">
									<template v-if="frmCliente.idel==0">
										<Badge value="DISPONIBLE" severity="success" ></Badge>
									</template>
									<template v-if="frmCliente.idel==1">
										<Badge value="BLOQUEADA" severity="danger" ></Badge>
									</template>
								</div>

								<h6>Estado Epayco</h6>
							
								<InputSwitch v-model="frmCliente.epaycopdn" @change="handleChangeepayco" /><br>
								<div class="mt-2 ml-2">
									<template v-if="frmCliente.epayco_pdn==0">
										<Badge value="PRUEBAS" severity="info" ></Badge>
									</template>
									<template v-if="frmCliente.epayco_pdn==1">
										<Badge value="PRODUCCION" severity="primary" ></Badge>
									</template>
								</div>
							</div>
							
							
							<!-- ACTIVA <InputSwitch v-model="frmCliente.estado" :value="estado_customer(frmCliente.status)" />{{estado_customer(frmCliente.status)}}
						</template>
						<template v-if="frmCliente.status==0 && frmCliente.idel==0">
							<h6>Estado</h6>
							INACTIVA <InputSwitch v-model="frmCliente.estado" :value="estado_customer(frmCliente.status)" />
						</template>
						<template v-if="frmCliente.idel==0">
							<h6>Estado</h6>
							BLOQUEADA <InputSwitch v-model="frmCliente.status" :value="false" />
						</template>
						<template v-if="frmCliente.idel==1">
							<h6>Estado</h6>
							BLOQUEADA <InputSwitch v-model="frmCliente.status" :value="false" /> -->
						<!-- </template> -->
						
					</div>
				</div>
				<div class="col-8 grid">
					<div class="field col-6">
						<span class="p-float-label">
							<InputText type="text" id="document" class="w-full" v-model="frmCliente.document" :class="{'p-invalid': submitted && !frmCliente.document}"/>
							<label for="document">Documento*</label>
						</span>
					</div>
					<div class="field col-6">
						<span class="p-float-label">
							<InputText type="text" id="name" class="w-full" v-model="frmCliente.name" :class="{'p-invalid': submitted && !frmCliente.name}"/>
							<label for="name">Razón Social*</label>
						</span>
					</div>
					<div class="field col-12">
						<span class="p-float-label">
							<InputText type="text" id="description" class="w-full" v-model="frmCliente.description" :class="{'p-invalid': submitted && !frmCliente.description}"/>
							<label for="description">Descripción*</label>
						</span>
					</div>
					<div class="field col-6">
						<span class="p-float-label">
							<InputText type="text" id="email" class="w-full" v-model="frmCliente.email" :class="{'p-invalid': submitted && !frmCliente.email}"/>
							<label for="email">Correo Notificaciones*</label>
						</span>
					</div>
					<div class="field col-6">
						<span class="p-float-label">
							<InputText type="text" id="contact" class="w-full" v-model="frmCliente.contact" :class="{'p-invalid': submitted && !frmCliente.contact}"/>
							<label for="contact">Contacto*</label>
						</span>
					</div>
					<div class="field col-6">
						<span class="p-float-label">
							<InputText type="text" id="public_key_epayco" class="w-full" v-model="frmCliente.public_key_epayco" :class="{'p-invalid': submitted && !frmCliente.public_key_epayco}"/>
							<label for="public_key_epayco">Public Key Epayco*</label>
						</span>
					</div>
					<div class="field col-6">
						<span class="p-float-label">
							<InputText type="text" id="private_key_epayco" class="w-full" v-model="frmCliente.private_key_epayco" :class="{'p-invalid': submitted && !frmCliente.private_key_epayco}"/>
							<label for="private_key_epayco">Private Key Epayco*</label>
						</span>
					</div>
					<div class="field col-12">
						<span class="p-float-label">
							<div class="color-picker-container">
								<label for="color_tapiz">Color de Fondo:</label>
								<ColorPicker v-model="frmCliente.color_tapiz" id="color_tapiz"/>
							</div>
						</span>
					</div>
					<template v-if="frmCliente.id!=0">
						<div class="field col-12">
							<label for="color_tapiz">Token Empresa:</label>
							<p class="link_tracking cursor-pointer" title="Copiar link" @click="copy_link_tracking(frmCliente.key)">{{frmCliente.key}} <i class="pi pi-link fs-xlarge blue-color"></i></p>
						</div>
					</template>
					<!-- <div class="col-12 px-8">
						<Button icon="pi pi-save" label="Guardar" :loading="loader" class="p-button-rounded button-sewayblue" @click="guardar_cliente" />
					</div> -->
				</div>
				
			</div>
			
			<template #footer>
				<Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modalcliente = false"/>
				<template v-if="frmCliente.id==0">
					<Button label="Guardar" icon="pi pi-save" class="p-button-text" :loading="loader" @click="guardar_cliente" />
				</template>
				<template v-else>
					<Button label="Editar" icon="pi pi-save" class="p-button-text" :loading="loader" @click="guardar_cliente" />
				</template>
			</template>
		</Dialog>
		<Dialog v-model:visible="modalimgCustomer" :style="{width: '600px'}" header="Logo de la Empresa de Transporte" :modal="true">
			<div class="flex align-items-center justify-content-center">
				<FileUpload
				name="files1"
				:customUpload="true" 
				@upload="onUpload1" 
				@uploader="beforeUpload1" 
				:fileLimit="1" 
				:multiple="true" 
				invalidFileLimitMessage="Se excedió el número máximo de archivos, el límite es 5 como máximo. " 
				accept="image/*" 
				:maxFileSize="1000000" 
				@select="onSelectedFiles"
				chooseLabel="Nuevo archivo"
				uploadLabel="Confirmar imagen y Guardar"
				cancelLabel="Cancelar imagen">
	
					<template #empty>
						<div class="flex align-items-center justify-content-center flex-column">
							<i class="pi pi-cloud-upload border-2 border-circle p-5 text-5xl text-400 border-400 mb-1" />
							<p class="text-center">Arrastre y suelte la imagen del logo de su empresa para cargarla (Se recomienda imagen con formato PNG para aplicar color al fondo).</p>
						</div>
					</template>
				</FileUpload>
			</div>
			<div class="flex align-items-center justify-content-center">
				<template v-if="loader==true">
					<i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
				</template>
			</div>
			<template #footer>
				<Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modalimgCustomer = false"/>
				<!-- <Button label="prueba" icon="pi pi-times" class="p-button-text" @click="onFileUpload"/> -->
			</template>
		</Dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loader: false,
			switchValue: false,
			submitted: false,
			modalimgCustomer: false,
			modalcliente: false,
			clientes: [],
			selectedClients: null,
            pagination: {
				current_page: 0,
				from: 0,
				last_page: 0,
				per_page: 0,
				to: 0,
				total: 0
			},
			frmfiltros: {
                nit_customer: '',
				name_customer: '',
            },
			frmCliente: {}
		}
	},
	mounted(){
		this.cargar_clientes(1);
	},
	methods:{
		onChangePage(page) {
			this.cargar_clientes(page.page+1);
		},
		limpiar(){
			this.frmfiltros.nit_customer = '';
			this.frmfiltros.name_customer = '';
			this.cargar_clientes(1);
		},
		handleChange(event) {
			console.log(event);
			const newValue = this.frmCliente.estado ? 1 : 0;
			
			console.log(newValue);

			this.frmCliente.status = newValue;
		},
		handleChangeIdel(event) {
			console.log(event);
			const newValue = this.frmCliente.disponibilidad ? 1 : 0;
			
			console.log(newValue);

			this.frmCliente.idel = newValue;
		},
		handleChangeepayco(event) {
			console.log(event);
			const newValue = this.frmCliente.epaycopdn ? 1 : 0;
			
			console.log(newValue);

			this.frmCliente.epayco_pdn = newValue;
		},
		cargar_clientes(page){
			this.loader = true;
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
				document.cookie.split(';').forEach(function(el) {
				let [key,value] = el.split('=');
				cookie[key.trim()] = value;
				})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
			this.clientes = [];
				window.api.call('post', '/cargar_clientes?&page='+page, {email: email,id_rol: id_rol,frmfiltros: this.frmfiltros}).then( function(response) {
					if(response.status == 200){
						_that.clientes = response.data.data.data;
						_that.pagination = response.data.data;
						_that.loader = false;
					}
				}).catch(function (err) {
					console.log(err);
					_that.loader = false;
					_that.loader_opt = false;
				});
		},
		openmodalClientes(data){
			this.modalcliente = true;
			this.frmCliente = data;
			if (data.status==1) {
				this.frmCliente.estado = true;
			}else{
				this.frmCliente.estado = false;
			}
			if (data.idel==1) {
				this.frmCliente.disponibilidad = true;
			}else{
				this.frmCliente.disponibilidad = false;
			}
			if (data.epayco_pdn==1) {
				this.frmCliente.epaycopdn = true;
			}else{
				this.frmCliente.epaycopdn = false;
			}
		},
		openNewClient(){
			this.modalcliente = true;
			this.frmCliente = {};
			this.frmCliente.id = 0;
		},
		openmodalmediaCustomer(){
			this.modalimgCustomer = true;
			this.loader = false;
		},
		onUpload1() {
			this.$toast.add({severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000});
		},
		beforeUpload1(request) {

			this.loader = true;
			var _that = this;
			let cookie = {};

			document.cookie.split(';').forEach(function(el) {
				let [key, value] = el.split('=');
				cookie[key.trim()] = value;
			})

			var formData = new FormData();
			for (let i = 0; i < request.files.length; i++) {
				formData.append(i, request.files[i])
			}
			console.log(formData);

			formData.append('frmCustomer', JSON.stringify(this.frmCliente));
			var url = 'guardar_imagen_customer';
			window.api.call('post', url, formData).then( function(response) {
				if(response.status == 200){
					_that.loader = false;
					_that.$toast.add({ severity: 'success', summary: 'Se Guardo Exitosamente', detail: 'Tu logo se encuentra visible en los archivos descargales', life: 6000 });
					_that.modalcliente = false;
					_that.modalimgCustomer = false;
					_that.frmCliente = response.data.data;
					// window.location.reload();
				}

			}).catch(function (err) {
				_that.loader = false;
				console.log(err);
				_that.modalimgCustomer = false;
				_that.$toast.add({severity:'error', summary: 'Ocurrio un error al guardar la imagen', detail:'', life: 4000});
			});
		},
		guardar_cliente(){
			this.loader = true;
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
				document.cookie.split(';').forEach(function(el) {
				let [key,value] = el.split('=');
				cookie[key.trim()] = value;
				})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
			this.clientes = [];
				window.api.call('post', '/guardar_cliente', {email: email,id_rol: id_rol,frmCliente: this.frmCliente}).then( function(response) {
					if(response.status == 200){
						_that.clientes = response.data.data.data;
						_that.pagination = response.data.data;
						_that.$toast.add({ severity: 'success', summary: 'Se Guardo Exitosamente', detail: 'Empresa de Transporte creada!', life: 6000 });
						_that.loader = false;
						_that.modalcliente = false;
					}
				}).catch(function (err) {
					console.log(err);
					_that.loader = false;
					_that.modalcliente = false;
					_that.loader_opt = false;
				});
		},
		copy_link_tracking(token){
			navigator.clipboard.writeText(token);
			this.$toast.add({severity:'success', summary: 'Copiado Correctamente', detail:'El token ya se encuentra disponible para enviar!', life: 4000});
		}

	}
}
</script>

<style scoped>
.color-picker-container {
    text-align: center; /* Centra el contenido horizontalmente */
}

.color-picker-container label {
    display: block; /* Muestra el label como bloque */
    margin-bottom: 10px; /* Añade un espacio entre el label y el ColorPicker */
}
.link_tracking:hover{
	color: rgb(0, 132, 255);
	transition: 0.5s;
}
</style>
